// detect if text fits horizontally in the container
export const isTextOverflowing = (element) => {
    return element.scrollWidth > element.clientWidth;
};
